import React from 'react';

import {useTranslation} from "react-i18next";
import Typography from '@mui/material/Typography';
import {sx} from './sx'
import {
    getPointLabelKeyStatusSingleVoyage
} from "@containers/singleVoyage/containers/points/helpers/getPointStatusLabelKey";
import {StatusWayPointSingleVoyage} from "@containers/singleVoyage/types/point";

interface IProps {
    status: StatusWayPointSingleVoyage
}

const StatusBarPointViewSingleVoyage = ({status}: IProps) => {

    const {t} = useTranslation()
    return (
        <Typography
            sx={sx.root}
            className={status}
        >
            {t(getPointLabelKeyStatusSingleVoyage(status))}
        </Typography>
    );
};

export default StatusBarPointViewSingleVoyage;